import Tooltip from 'antd/es/tooltip';
import { EyeIcon, EyeSlashIcon } from 'shared/ui/icons';

const PasswordInputField = ({
  name,
  placeholder,
  value,
  onChange,
  showPassword,
  onToggle,
  error,
  tooltip,
}) => {
  const inputField = (
    <input
      id={name}
      name={name}
      type={showPassword ? 'text' : 'password'}
      autoComplete="one-time-code"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      className="block w-full rounded-md border-0 py-2 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-500 focus:outline-none sm:text-sm sm:leading-6"
    />
  );

  return (
    <div className="my-0">
      <div className="mt-2 relative">
        {tooltip ? (
          <Tooltip
            placement="bottom"
            title={value ? null : tooltip}
            destroyTooltipOnHide
            trigger={['focus', 'hover']}
          >
            {inputField}
          </Tooltip>
        ) : (
          inputField
        )}
        <button
          type="button"
          onClick={onToggle}
          className="absolute top-1/2 right-3 -translate-y-1/2 flex items-center bg-white"
        >
          {showPassword ? (
            <EyeSlashIcon color="#6b7280" />
          ) : (
            <EyeIcon color="#6b7280" />
          )}
        </button>
      </div>
      {error && (
        <div className="mt-0.5 w-full justify-start items-start flex">
          <span className="text-red-500 text-sm">{error}</span>
        </div>
      )}
    </div>
  );
};

export default PasswordInputField;
